// Card for a selected system (GDD 08 quick-info, spec 15c §3.7): name, type, owner with emblem and
// tag, planets, shield; View system and Send fleet.
import type { GalaxyMeResponse, MapSystem } from '@stars-and-ships/api-types';
import { Shield } from 'lucide-react';
import { useNavigate } from 'react-router';
import { SYSTEM_TYPE_LABELS } from '../../labels';
import { Emblem } from '../alliance/Emblem';
import { OwnerLinks } from '../ProfileLinks';
import { PlanetsLine } from '../system/shared';
import { Button } from '../ui';
import { MAP_CARD_CLASS } from './FleetCard';

export function SystemCard({
  galaxyId,
  system,
  me,
  isHome,
  onClose,
}: {
  galaxyId: string;
  system: MapSystem;
  me: GalaxyMeResponse | undefined;
  isHome: boolean;
  onClose(): void;
}) {
  const navigate = useNavigate();
  const owner = system.owner;
  const own = owner !== null && owner.playerId === me?.playerId;
  const ally = !own && Boolean(me?.alliance && owner?.alliance?.id === me.alliance.id);
  return (
    <aside data-map-card="system" className={MAP_CARD_CLASS}>
      <div className="flex items-start justify-between gap-2">
        <div className="flex min-w-0 items-start gap-2">
          {owner?.alliance ? (
            <Emblem emblem={owner.alliance.emblem} tag={owner.alliance.tag} size="sm" />
          ) : null}
          <div className="min-w-0">
            <h2 className="font-display text-lg font-bold uppercase tracking-[0.08em] text-text">
              {system.name}
            </h2>
            <p className="text-xs text-muted">
              {own ? (isHome ? 'Home system · ' : 'Your system · ') : ''}
              {SYSTEM_TYPE_LABELS[system.systemType]} · {ally ? 'Ally · ' : ''}
              <OwnerLinks galaxyId={galaxyId} owner={owner} myPlayerId={me?.playerId} />
            </p>
            <PlanetsLine system={system} />
          </div>
        </div>
        {system.ownerShielded ? (
          <Shield className="size-5 shrink-0 text-info" aria-label="Beginner shield" />
        ) : null}
      </div>
      <div className="mt-3 flex gap-2">
        <Button className="flex-1" onClick={() => navigate(`/g/${galaxyId}/systems/${system.id}`)}>
          View system
        </Button>
        <Button
          variant="secondary"
          onClick={() => navigate(`/g/${galaxyId}/fleet/send?target=${system.id}`)}
        >
          Send fleet
        </Button>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </div>
    </aside>
  );
}
